export const AutomationRuleCreate = {
  Type: "type" as const,
  ReceiptDraft: "receiptDraft" as const,
}

export const CreateReceiptDraftRule = {
  Category: "category" as const,
  PaymentMethodId: "paymentMethodId" as const,
  MinimumAmount: "minimumAmount" as const,
  MaximumAmount: "maximumAmount" as const,
  MaxAutomatedEventsPerMonth: "maxAutomatedEventsPerMonth" as const,
  Supplier: "supplier" as const,
  Dimensions: "dimensions" as const,
  IsActive: "isActive" as const,
}

export const Filter = {
  Type: "type" as const,
  TotalProcessedEvents: "totalProcessedEvents" as const,
  CreatedDate: "createdDate" as const,
  Active: "active" as const,
}

